import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceEventEditionNotificationState = createStateReducer(initialState, {
  [events.editEventSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editEvent",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editEventFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editEvent",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceEventEditionNotificationState };
